/** @format */

import './polyfills';
import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {isSensitivePage} from './sharing/privacy';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

serviceWorker.register();

// Firebase analytics is not needed for first paint — load after idle
const bootFirebase = () => {
  if (isSensitivePage()) return;
  import('firebase/app')
    .then(firebaseModule => {
      const firebase = firebaseModule.default || firebaseModule;
      return Promise.all([import('firebase/analytics'), import('firebase/performance')]).then(() => firebase);
    })
    .then(firebase => {
      if (isSensitivePage()) return;
      if (firebase.apps && firebase.apps.length) return;
      firebase.initializeApp({
        apiKey: 'AIzaSyBUIuPJNXopioYyyB-IkS-wOROfwzW3LsA',
        authDomain: 'gpson-176022.firebaseapp.com',
        databaseURL: 'https://gpson-176022.firebaseio.com',
        projectId: 'gpson-176022',
        storageBucket: 'gpson-176022.appspot.com',
        messagingSenderId: '421033511233',
        appId: '1:421033511233:web:ddde583c0723a683f639c0',
        measurementId: 'G-QNHRM0LMTS',
      });
      firebase.analytics();
      const protectShare = () => firebase.analytics().setAnalyticsCollectionEnabled(!isSensitivePage());
      protectShare();
      window.addEventListener('hashchange', protectShare);
      firebase.performance();
    })
    .catch(() => {});
};

if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
  window.requestIdleCallback(bootFirebase);
} else {
  setTimeout(bootFirebase, 2000);
}
